<div class="d-flex justify-content-center mt-4">
  <div class="d-flex align-items-center" style="border:1px solid #920000;border-radius: 5px;height:150px;">
    <p class="p-4" style="font-size:24px;font-weight:bold;">Sidan kunde inte hittas. Kontrollera URL:en.</p>
  </div>
</div>